import { render, staticRenderFns } from "./SalarySampleDefaultBriefDialog.vue?vue&type=template&id=417e843c&scoped=true"
import script from "./SalarySampleDefaultBriefDialog.vue?vue&type=script&lang=js"
export * from "./SalarySampleDefaultBriefDialog.vue?vue&type=script&lang=js"
import style0 from "./SalarySampleDefaultBriefDialog.vue?vue&type=style&index=0&id=417e843c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417e843c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('417e843c')) {
      api.createRecord('417e843c', component.options)
    } else {
      api.reload('417e843c', component.options)
    }
    module.hot.accept("./SalarySampleDefaultBriefDialog.vue?vue&type=template&id=417e843c&scoped=true", function () {
      api.rerender('417e843c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/SalarySampleDefaultBriefDialog.vue"
export default component.exports